import { useTranslation } from 'react-i18next';

import type portalSchema from 'support/types/schema-portal';

import { Badge, BadgeColor } from 'components/Display/Badge/Badge';

type NotificationResolving = portalSchema.components['schemas']['NotificationResolving'];

type NotificationRoutingBadgeProps = {
  notificationResolving?: NotificationResolving | null;
  className?: string;
};

export const NotificationRoutingBadge = ({ notificationResolving, className }: NotificationRoutingBadgeProps) => {
  const { t } = useTranslation();

  if (notificationResolving !== 'accept_named_responsible') {
    return null;
  }

  return (
    <div className={className}>
      <Badge
        color={BadgeColor.blue}
        tooltip={t('settings:notificationsManagement.routingBadge.documentSpecificContactsTooltip')}
      >
        {t('settings:notificationsManagement.routingBadge.documentSpecificContacts')}
      </Badge>
    </div>
  );
};
